import { Colors, Fonts, Metrics } from '../../../../../shared/theme';
import styled from 'styled-components';
import { textStyles } from '../../../../../shared/theme/fonts-ppv';

export default {
  marginBottom: {
    marginBottom: 0
  } as React.CSSProperties,
  inlineBlock: {
    display: 'inline-block'
  } as React.CSSProperties,
  spaceSelect: {
    width: Metrics.baseMarginButton
  },
  uploadBox: {
    display: 'flex',
    height: '128px',
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  upload: {
    borderStyle: 'solid',
    borderColor: Colors.violet600,
    borderRadius: '5px',
    borderWidth: '1px',
    backgroundColor: 'transparent',
    height: '40px',
    minWidth: '100px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 8,
    paddingRight: 8,
  },
  imageStyle: {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
  },
  imageBox: {
    backgroundColor: '#F8F8F8',
    height: '128px',
    width: '128px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #E8E8E8',
  },
  coverImageBox: {
    backgroundColor: '#F8F8F8',
    height: '128px',
    aspectRatio: '2/1',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #E8E8E8',
  },
  shopImageDefault: {
    width: '32px',
    height: '32px',
    filter: 'grayscale(100%) opacity(0.3)',
  },
  paddingWarning: {
    paddingTop: '8px'
  },
  regular14fakeBlack: {
     ...textStyles.subtitle2,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.fakeBlack
  },
  light14darkGray: {
    paddingLeft: '25px',
    paddingBottom: '16px',
     ...textStyles.body2,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.darkGray
  },
  light14darkGrayNoPaDingBottom: {
    paddingLeft: '25px',
     ...textStyles.body2,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.darkGray
  },
  light14darkGrayNoPaDingBottom8: {
    paddingBottom: '8px',
    paddingLeft: '25px',
     ...textStyles.body2,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.darkGray
  },
  light14fakeBlack: {
    ...textStyles.body2,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.fakeBlack
  },
  calendarBox: {
    paddingBottom: 0,
    paddingTop: 0,
    paddingLeft: '15px',
  },
  calendarInput: {
    width: '200px'
  },
  text14RegularFakeBlack: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.fakeBlack,
  },
  qcStatusRemark: {
    marginTop: Metrics.baseMargin,
    marginBottom: Metrics.baseMargin,
    whiteSpace: "pre-line"
  },
  confirmDialogBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: 480,
    backgroundColor: Colors.white,
    borderRadius: 16,
  } as React.CSSProperties,
  confirmDialogContent: {
    padding: 24,
  } as React.CSSProperties,
  confirmDialogIcon: {
    color: Colors.tagYellow,
    fontSize: 20,
    lineHeight: '28px',
  } as React.CSSProperties,
  confirmDialogTitle: {
    ...textStyles.h3,
    color: Colors.textPrimary,
  } as React.CSSProperties,
  confirmDialogMessage: {
    ...textStyles.body1,
    color: Colors.secondary,
    marginTop: 8,
  } as React.CSSProperties,
  confirmDialogFooter: {
    gap: 8,
    padding: '12px 24px',
    borderTop: `1px solid ${Colors.grey100}`,
  } as React.CSSProperties,
  confirmDialogCancelButton: {
    padding: '10px 24px',
    height: 'auto',
    border: `1px solid ${Colors.grey200}`,
    borderRadius: 48,
    color: Colors.grey800,
    backgroundColor: Colors.white,
    ...textStyles.subtitle2,
  } as React.CSSProperties,
  confirmDialogConfirmButton: {
    padding: '10px 24px',
    height: 'auto',
    border: 'none',
    borderRadius: 48,
    color: Colors.white,
    backgroundColor: Colors.violet600,
    ...textStyles.subtitle2,
  } as React.CSSProperties,
};

export const layout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 16 },
};

export const StyleWrapper = styled.div`
  .ant-input-group > .ant-input:first-child, .ant-input-group-addon:first-child {
    font-size: 14px;
  }
  .ant-picker-large .ant-picker-input > input {
    font-size: 14px;
  }

  .ant-input, .ant-select {
    max-width: 100%;
  }
`;
